/**
 * Stable CSS class names for E2E — GetOrderActionRules card.
 */
export const SM_GOAR = {
    card: 'service-managment-order-action-rules__card',

    toggleRow: 'service-managment-order-action-rules__toggle-row',
    toggleRowLabel: 'service-managment-order-action-rules__toggle-row-label',
    toggleRowBadge: 'service-managment-order-action-rules__toggle-row-badge',
    toggleRowToggle: 'service-managment-order-action-rules-input--toggle-row',

    divider: 'service-managment-order-action-rules__divider',

    switchPair: 'service-managment-order-action-rules__switch-pair',
    switchPairSide: 'service-managment-order-action-rules__switch-pair-side',
    switchPairLabel: 'service-managment-order-action-rules__switch-pair-label',
    switchPairToggle: 'service-managment-order-action-rules-input--toggle-switch-pair',

    group: 'service-managment-order-action-rules__group',
    groupTitle: 'service-managment-order-action-rules__group-title',
} as const;

export const smGoarCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

